export const CprToDateOfBirth = (cpr: string): string => {

    let day: string = cpr.substring(0, 2)
    let month: string = cpr.substring(2, 4)
    let year: number = parseInt(cpr.substring(4, 6))
    let yearString: string = cpr.substring(4, 6)

    let century: string = "";
    var seventhDigit: string = cpr[6];

    // Se cpr dokumentation https://cpr.dk/media/12066/personnummeret-i-cpr.pdf
    switch (seventhDigit) {
        case '0':
        case '1':
        case '2':
        case '3':
            century = "19";
            break;
        case '4':
        case '9':
            century = year <= 36 ? "20" : "19";
            break;
        case '5':
        case '6':
        case '7':
        case '8':
            century = year <= 57 ? "20" : "18";
            break;
    }

    return `${century}${yearString}-${month}-${day}`;
}

